import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

import { moment } from "../../../utils/LocalizedUtils";

import { setFilter, requestConferences, resetFilter } from "../../../actions/passcodeManager";

const fieldSx = theme => ({
  ml: 1,
  mr: 1,
  flexGrow: 1,
});

export const PMConferencesFilterComponent = ({
  filter,
  requestPMConferncesInProgress,
  translate,
  setFilterFn,
  clearFilterFn,
  requestConferencesFn,
}) => {
  const handleTextChange = name => event => {
    setFilterFn({ ...filter, [name]: event.target.value });
  };

  const handleDateChange = (name, date) => {
    setFilterFn({ ...filter, [name]: moment.utc(date) });
  };

  const createdTextSx = theme => ({
    pt: 2,
    pr: 1,
    pb: 1,
    pl: 1,
    fontSize: 15,
  });

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
      <Typography variant="subtitle1" id="filterTitle">
        Filter
      </Typography>
      <Box sx={{ width: "100%" }} />
      <TextField
        id="conferences-confId"
        label={translate.conferenceId}
        sx={fieldSx}
        value={filter.confId ?? ""}
        onChange={handleTextChange("confId")}
      />
      <TextField
        id="conferences-hostPasscode"
        label={translate.hostPasscode}
        sx={fieldSx}
        value={filter.hostPasscode ?? ""}
        onChange={handleTextChange("hostPasscode", true)}
      />
      <TextField
        id="conferences-guestPasscode"
        label={translate.guestPasscode}
        sx={fieldSx}
        value={filter.guestPasscode ?? ""}
        onChange={handleTextChange("guestPasscode", true)}
      />
      <Box sx={{ width: "100%" }} />
      <TextField
        id="conferences-eMail"
        label={translate.ownerEmail}
        sx={fieldSx}
        value={filter.eMail ?? ""}
        onChange={handleTextChange("eMail")}
      />
      <TextField
        id="conferences-comment"
        label={translate.comment}
        sx={fieldSx}
        value={filter.comment ?? ""}
        onChange={handleTextChange("comment")}
      />
      <TextField
        id="conferences-contractNumber"
        label={translate.contractNo}
        sx={fieldSx}
        value={filter.contractNumber ?? ""}
        onChange={handleTextChange("contractNumber")}
      />
      <Box sx={{ width: "100%" }} />
      <Box sx={createdTextSx}>{translate.creationDate}</Box>
      <DateTimePicker
        ampm={false}
        format="DD.MM.YYYY HH:mm:ss"
        value={filter.creationDateFrom ? moment(filter.creationDateFrom) : null}
        onChange={date => handleDateChange("creationDateFrom", date)}
        slotProps={{
          textField: {
            id: "conferences-creation-date-from",
            label: translate.from,
            sx: fieldSx,
          },
        }}
      />
      <Box sx={createdTextSx}>-</Box>
      <DateTimePicker
        ampm={false}
        format="DD.MM.YYYY HH:mm:ss"
        value={filter.creationDateTo ? moment(filter.creationDateTo) : null}
        onChange={date => handleDateChange("creationDateTo", date)}
        slotProps={{
          textField: {
            id: "conferences-creation-date-to",
            label: translate.to,
            sx: fieldSx,
          },
        }}
      />
      <Box sx={{ mt: 1, width: "100%", display: "inline-flex" }}>
        <Box sx={{ flex: 1, width: "10px" }} />
        <Button size="small" onClick={() => clearFilterFn()}>
          {translate.clearButtonFilter}
        </Button>
        <Button
          disabled={requestPMConferncesInProgress}
          variant="contained"
          size="small"
          color="primary"
          onClick={() => {
            setFilterFn({ ...filter, page: 0 });
            requestConferencesFn({ ...filter, page: 0 });
          }}
        >
          {translate.searchButtonFilter}
        </Button>
      </Box>
    </Box>
  );
};

PMConferencesFilterComponent.propTypes = {
  filter: PropTypes.object.isRequired,
  setFilterFn: PropTypes.func.isRequired,
  clearFilterFn: PropTypes.func.isRequired,
  translate: PropTypes.object.isRequired,
  requestConferencesFn: PropTypes.func.isRequired,
  requestPMConferncesInProgress: PropTypes.bool.isRequired,
};

const mapDispatchToProps = dispatch => ({
  setFilterFn: filter => dispatch(setFilter(filter)),
  requestConferencesFn: filter => dispatch(requestConferences(filter)),
  clearFilterFn: () => dispatch(resetFilter()),
});

const mapStateToProps = state => ({
  filter: state.passcodeManager.filter,
  requestPMConferncesInProgress: state.passcodeManager.requestPMConferncesInProgress,
  translate: state.ui.translate,
});

const PMConferencesFilter = connect(
  mapStateToProps,
  mapDispatchToProps
)(PMConferencesFilterComponent);

export default PMConferencesFilter;
